<template>
  <v-container fluid>
    <v-layout row justify-end class="button-padding">
      <div>
        <v-btn
          color="primary"
          depressed
          large
          :disabled="!isInvoiceSelected()"
          :loading="loading"
          @click="bulkDownload()"
        >
          Herunterladen
        </v-btn>
        <v-btn
          color="secondary"
          depressed
          large
          :disabled="!isInvoiceSelectedReleased()"
          @click="bulkRelease()"
        >
          Veröffentlichen
        </v-btn>
        <v-btn
          color="warning"
          depressed
          large
          :disabled="!isInvoiceSendable()"
          @click="bulkSend()"
        >
          E-Mail versenden
        </v-btn>
        <v-flex></v-flex>
      </div>
    </v-layout>
    <v-layout
      column
      fill-height
      id="allCustomerInvoices"
      style="max-height: calc(100vh - 192px);"
      class="overflow-y-auto"
    >
      <v-flex
        v-scroll:#allCustomerInvoices="onScroll"
        align="center"
        justify="center"
      >
        <v-list v-for="(monthGroup, index) in monthlyGroupInvoices" v-bind:key="monthGroup.month">
          <v-subheader v-if="monthGroup.month">
              <v-checkbox color="primary"
              v-model="selectedMonths[index]"
              @change="monthSelectionChanged(monthGroup.month, $event)"
            >
              <template v-slot:label>
                <div><strong class="primary--text month-header-text">{{mapYearMonth(monthGroup.month)}}</strong></div>
              </template>
            </v-checkbox>
            <v-flex></v-flex>
            <v-btn
            @click="openTurnoverPdf(monthGroup.month)"
            >Umsatz</v-btn>
            </v-subheader>
          <template v-for="(invoice, invoiceIndex) in monthGroup.invoices">
            <v-list-item v-if="invoiceIndex % 2 === 1"
              :key="invoice.id" style="background-color: #B3E5FC40">
              <v-checkbox
                color="black"
                v-model="selectedInvoices[invoice.id]"
                @change="invoiceSelectionChanged(invoice, index, $event)"
              ></v-checkbox>
              <v-list-item-icon>
                <v-icon v-if="invoice.released" color="primary">lock</v-icon>
                <v-icon v-else>lock_open</v-icon>
              </v-list-item-icon>
              <v-list-item-icon>
                <v-icon v-if="isMailDelivered(invoice)" color="primary">mail</v-icon>
                <v-icon v-if="isMailNotDelivered(invoice)">mail</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{listItemLabel1(invoice)}}</v-list-item-title>
                <v-list-item-subtitle>{{listItemLabel2(invoice)}}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn text icon :disabled="isRowDisabled(invoice.id)"
                       @click="openCustomerInvoice(invoice.id)"
                >
                  <v-icon color="primary">receipt</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action v-if="!invoice.released">
                <v-btn text icon :disabled="isRowDisabled(invoice.id)"
                       @click="releaseInvoice(invoice)"
                >
                  <v-icon color="primary">publish</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action v-if="invoice.released">
                <v-btn text icon :disabled="isRowDisabled(invoice.id)"
                       @click="sendInvoice(invoice)"
                >
                  <v-icon color="primary">forward_to_inbox</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-else
              :key="invoice.id">
              <v-checkbox
                color="black"
                v-model="selectedInvoices[invoice.id]"
                @change="invoiceSelectionChanged(invoice, index, $event)"
              ></v-checkbox>
              <v-list-item-icon>
                <v-icon v-if="invoice.released" color="primary">lock</v-icon>
                <v-icon v-else>lock_open</v-icon>
              </v-list-item-icon>
              <v-list-item-icon>
                <v-icon v-if="isMailDelivered(invoice)" color="primary">mail</v-icon>
                <v-icon v-if="isMailNotDelivered(invoice)">mail</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{listItemLabel1(invoice)}}</v-list-item-title>
                <v-list-item-subtitle>{{listItemLabel2(invoice)}}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn text icon :disabled="isRowDisabled(invoice.id)"
                 @click="openCustomerInvoice(invoice.id)"
                >
                  <v-icon color="primary">receipt</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action v-if="!invoice.released">
                <v-btn text icon :disabled="isRowDisabled(invoice.id)"
                 @click="releaseInvoice(invoice)"
                >
                  <v-icon color="primary">publish</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action v-if="invoice.released">
                <v-btn text icon :disabled="isRowDisabled(invoice.id)"
                  @click="sendInvoice(invoice)"
                >
                  <v-icon color="primary">forward_to_inbox</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="invoiceIndex + 1 < monthGroup.invoices.length"
              :key="monthGroup+'-divider-'+invoiceIndex"
            ></v-divider>
          </template>
        </v-list>
        <release-invoice-dialog
          :invoice="selectedInvoice"
          :invoices="selectedInvoicesToRelease"
          :yearMonth="selectedMonth"
          :show="showReleaseInvoiceDialog"
          @close="closeReleaseInvoiceDialog"
          v-on:cancel="closeReleaseInvoiceDialogAndRetainData"
        ></release-invoice-dialog>
        <send-invoice-dialog
          :invoice="selectedInvoice"
          :invoices="selectedInvoicesToSend"
          :yearMonth="selectedMonth"
          :show="showSendInvoiceDialog"
          @close="closeSendInvoiceDialog"
          v-on:cancel="closeSendInvoiceDialogAndRetainData"
        ></send-invoice-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import releaseInvoiceConfirmDialog from './ReleaseInvoiceConfirmDialog'
  import sendInvoiceConfirmDialog from './SendInvoiceConfirmDialogue'

  export default {
    name: 'CustomerInvoiceList',
    data () {
      return {
        page: 0,
        size: 50,
        bottom: false,
        disabledInvoice: 0,
        showReleaseInvoiceDialog: false,
        showSendInvoiceDialog: false,
        selectedInvoice: {
          id: 0,
          released: false,
          delivered: false
        },
        editableCustomerInvoices: null,
        selectedMonth: '',
        selectedMonths: [],
        selectedInvoices: [],
        selectedInvoicesToRelease: [],
        selectedInvoicesToSend: []
      }
    },
    components: {
      'release-invoice-dialog': releaseInvoiceConfirmDialog,
      'send-invoice-dialog': sendInvoiceConfirmDialog
    },
    watch: {
      bottom (bottom) {
        if (bottom) {
          this.page++
          this.loadCustomerInvoices()
        }
      },
      disabled (newValue, oldValue) {
        if (!newValue) {
          this.disabledInvoice = 0
        }
      },
      monthlyGroupInvoices: {
        deep: true,
        handler () {
          this.selectAllInvoicesOfSelectedMonth()
        }
      }
    },
    computed: {
      monthlyGroupInvoices: function () {
        return this.$store.getters.customerInvoices
      },
      disabled: function () {
        return this.$store.getters.startDataLoading
      },
      loading: function () {
        return this.$store.getters.loading
      }
    },
    created () {
      window.addEventListener('scroll', () => {
        this.bottom = this.onScroll()()
      })
      this.$store.dispatch('resetCustomerInvoices')
      this.loadCustomerInvoices()
    },
    methods: {
      loadCustomerInvoices: function () {
        this.$store.dispatch('loadCustomerInvoices', {
          page: this.page,
          size: this.size
        })
      },
      monthSelectionChanged: function (month, event) {
        if (event) {
          this.selectedMonth = month
          this.selectAllInvoicesOfSelectedMonth()
        } else {
          this.deselectAllInvoicesOfSelectedMonth()
          this.selectedMonth = ''
        }
      },
      selectAllInvoicesOfSelectedMonth: function () {
        this.monthlyGroupInvoices.forEach(monthGroup => {
          monthGroup.invoices.forEach(invoice => {
            if (this.selectedMonth === monthGroup.month) {
              this.selectedInvoices[invoice.id] = true
            }
          })
        })
      },
      deselectAllInvoicesOfSelectedMonth: function () {
        this.monthlyGroupInvoices.forEach(monthGroup => {
          monthGroup.invoices.forEach(invoice => {
            if (this.selectedMonth === monthGroup.month) {
              this.selectedInvoices[invoice.id] = false
            }
          })
        })
      },
      invoiceSelectionChanged: function (invoice, monthIndex, event) {
        if (!event) {
          this.selectedMonths[monthIndex] = event
          this.selectedMonth = ''
        }
      },
      onScroll: function (e) {
        const scrollY = e.target.scrollTop
        const visible = e.target.clientHeight
        const pageHeight = e.target.scrollHeight - 64.0 // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
        const bottomOfPage = visible + scrollY >= pageHeight
        this.bottom = bottomOfPage || pageHeight < visible
      },
      isRowDisabled: function (invoiceId) {
        return this.disabledInvoice === invoiceId
      },
      isMailDelivered: function (invoice) {
        return invoice.delivered && invoice.customer.email !== ''
      },
      isMailNotDelivered: function (invoice) {
        return !invoice.delivered && invoice.customer.email !== ''
      },
      openCustomerInvoice: function (id) {
        this.$store.dispatch('openInvoice', id)
      },
      openTurnoverPdf: function (yearMonth) {
        this.$store.dispatch('openTurnover', yearMonth)
      },
      releaseInvoice: function (invoice) {
        this.selectedInvoice = invoice
        this.showReleaseInvoiceDialog = true
      },
      sendInvoice: function (invoice) {
        this.selectedInvoice = invoice
        this.showSendInvoiceDialog = true
      },
      closeReleaseInvoiceDialog: function () {
        this.showReleaseInvoiceDialog = false
        this.selectedInvoice = {
          id: 0,
          released: false,
          delivered: false
        }
        this.selectedInvoices = []
        this.selectedMonths = []
        this.selectedMonth = ''
      },
      closeReleaseInvoiceDialogAndRetainData: function () {
        this.showReleaseInvoiceDialog = false
      },
      closeSendInvoiceDialog: function () {
        this.showSendInvoiceDialog = false
        this.selectedInvoice = {
          id: 0,
          released: false,
          delivered: false
        }
        this.selectedInvoices = []
        this.selectedMonths = []
        this.selectedMonth = ''
      },
      closeSendInvoiceDialogAndRetainData: function () {
        this.showSendInvoiceDialog = false
      },
      mapYearMonth: function (yearMonth) {
        const splitted = yearMonth.split('-')
        const date = new Date(splitted[0], splitted[1] - 1)
        return date.toLocaleString('de-de', { month: 'long' }) + ' ' + splitted[0]
      },
      isInvoiceSelected: function () {
        return this.selectedInvoices.some((element) => element === true)
      },
      isInvoiceSelectedReleased: function () {
        if (!this.isInvoiceSelected()) return
        const selectedInvoices = this.getInvoices(this.getSelectedInvoiceIds())
        return selectedInvoices.some((element) => !element.released)
      },
      isInvoiceSendable: function () {
        if (!this.isInvoiceSelected()) return
        const selectedInvoices = this.getInvoices(this.getSelectedInvoiceIds())
        return selectedInvoices.some((element) => element.customer.email && element.released)
      },
      getInvoices: function (invoiceIds) {
        if (Array.isArray(invoiceIds) && invoiceIds.length <= 0) return
        const selectedInvoices = []
        this.monthlyGroupInvoices.forEach(monthGroup => {
          monthGroup.invoices.forEach(invoice => {
            if (invoiceIds.includes(invoice.id)) {
              selectedInvoices.push(invoice)
            }
          })
        })
        return selectedInvoices
      },
      getSelectedInvoiceIds: function () {
        return this.selectedInvoices
          .map((value, index) => ({id: index, selected: value}))
          .filter((element) => element.selected === true)
          .map((element) => element.id)
      },
      bulkDownload: function () {
        if (this.selectedMonth) {
          this.$store.dispatch('bulkCustomerInvoiceDownloadByMonth', this.selectedMonth)
        } else {
          const selectedInvoiceIds = this.getSelectedInvoiceIds()
          if (selectedInvoiceIds.length === 1) {
            this.openCustomerInvoice(selectedInvoiceIds[0])
          } else {
            this.$store.dispatch('bulkCustomerInvoiceDownloadByInvoices', selectedInvoiceIds)
          }
        }
        this.selectedMonth = ''
        this.selectedMonths = []
        this.selectedInvoices = []
      },
      bulkRelease: function () {
        const selectedInvoiceIds = this.getSelectedInvoiceIds()
        if (selectedInvoiceIds.length === 1) {
          this.selectedInvoice = this.findInvoice(selectedInvoiceIds[0])
        }
        this.selectedInvoicesToRelease = selectedInvoiceIds
        this.showReleaseInvoiceDialog = true
      },
      bulkSend: function () {
        const selectedInvoiceIds = this.getSelectedInvoiceIds()
        if (selectedInvoiceIds.length === 1) {
          this.selectedInvoice = this.findInvoice(selectedInvoiceIds[0])
        }
        this.selectedInvoicesToSend = selectedInvoiceIds
        this.showSendInvoiceDialog = true
      },
      findInvoice: function (invoiceId) {
        return this.monthlyGroupInvoices.reduce((arr, monthGroup) => arr.concat(monthGroup.invoices), [])
          .find(invoice => invoice.id === invoiceId)
      },
      listItemLabel1: function (invoice) {
        if (invoice.type.toUpperCase() === 'CUSTOMER_INVOICE') {
          return invoice.customer.lastName + ' ' + invoice.customer.firstName
        }
      },
      listItemLabel2: function (invoice) {
        if (invoice.type.toUpperCase() === 'CUSTOMER_INVOICE') {
          return invoice.customer.street + ', ' + invoice.customer.city
        }
      }
    }
  }
</script>

<style scoped>
  .v-list-item {
    max-height: 50px;
  }

  .button-padding {
    padding-right: 30px;
  }

  .month-header {
    max-height: 35px;
    margin-left: 16px;
    margin-bottom: 5px;
  }

  .month-header-text {
    font-size: x-large;
  }
</style>



// WEBPACK FOOTER //
// src/components/Invoices/CustomerInvoiceList.vue